import React from 'react';
import { Category } from '../../../utils/api/category/category.type';
import { getImage } from '../../../utils/Utils';
import Empty from "../../../assets/images/icons/icon2.svg";
import SubCategoriesModal from './SubCategoriesModal';
import ProductsModal from './ProductsModal';
import { ApiBaseUrl } from '../../../utils/http';

const resolveCategoryImage = (item?: Partial<Category> & Record<string, any>) => {
    if (!item) return Empty;

    const raw = item.images ?? item.image ?? item.cover ?? item.thumbnail;
    if (!raw || typeof raw !== "string") return Empty;

    if (raw.startsWith("http://") || raw.startsWith("https://")) {
        return raw;
    }
    if (raw.startsWith("/media") || raw.startsWith("media/")) {
        return `${ApiBaseUrl}${raw.startsWith("/") ? raw : `/${raw}`}`;
    }
    if (raw.startsWith("/api/") || raw.startsWith("api/")) {
        return `${ApiBaseUrl}${raw.startsWith("/") ? raw : `/${raw}`}`;
    }

    return getImage(raw);
};


export const CategoryCard = ({ category }: { category: Category }) => {
    const [show, setShow] = React.useState<boolean>(false);
    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);
    return (
        <>
            <div
                className="category-card"
                role="button"
                onClick={handleShow}
            >
                <div className="cover-wrapper">
                    <img
                        src={resolveCategoryImage(category)}
                        alt="cover"
                        onError={(event) => {
                            event.currentTarget.src = Empty;
                        }}
                    />
                </div>
                <h5 className="title-category-product-item-mobile">
                    {category?.nom}
                </h5>
            </div>
            <SubCategoriesModal
                show={show}
                handleClose={handleClose}
                category={category}
            />
        </>
    )
}


export const SubCategoryCard = (
    { category, subCategory }:
        { category: Category, subCategory: Category }
) => {
    const [show, setShow] = React.useState<boolean>(false);
    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);
    return (
        <>
            <div
                className="category-card"
                role="button"
                onClick={handleShow}
            >
                <div className="cover-wrapper">
                    <img
                        src={resolveCategoryImage(subCategory)}
                        alt="cover"
                        onError={(event) => {
                            event.currentTarget.src = Empty;
                        }}
                    />
                </div>
                <h5 className="title-category-product-item-mobile">
                    {subCategory?.nom}
                </h5>
            </div>
            <ProductsModal
                show={show}
                handleClose={handleClose}
                subCategory={subCategory}
            />
        </>
    )
}
